<template>
  <div>
    <div v-if="singleForm" id="basicInfoQuestionMultiSelect">
      <div class="text-center">Select all that apply</div>
      <div class="d-flex flex-wrap justify-content-between" :dreams-id="question.attributes[0].alias">
        <label
          class="single-form-selection-pill p-sm rounded position-relative p-1 mb-1"
          v-bind:class="{
            'selection-pill--selected': option.boolValue,
            'selection-pill--focused': option.focused,
            'selection-pill--invalid': v$.valueArray && v$.valueArray.$error,
          }"
          v-for="(option, index) in options"
          :key="index"
          :for="'biq-' + question.id + '-' + index"
          @keydown.enter="onEnter(options)"
          @keydown.space="toggleValue(option, options, $event)">
          <div class="option-box text-center d-table w-100">
            <input type="checkbox"
                   class="selection-pill__check position-absolute top-0 start-0 bottom-0 end-0"
                   :id="'biq-' + question.id + '-' + index"
                   :name="'biq-' + question.id + '-' + index"
                   @focus="onFocus(option)"
                   @blur="onBlur(v$, option)"
                   @invalidity="$emit('invalidity', $event)"
                   @change="saveValue(options, singleForm)"
                   v-model="option.boolValue">

            <div class="single-form-option-box__label d-table-cell align-middle my-0 mx-auto">
              {{ option.label }}
            </div>
          </div>
        </label>
        <!-- These empty option boxes are to set a fixed left alignment on the bottom row -->
        <span v-if="options.length > 4" class="single-form-flex-spacer mb-1"></span>
        <span v-if="options.length > 4" class="single-form-flex-spacer mb-1"></span>
        <span v-if="options.length > 4" class="single-form-flex-spacer mb-1"></span>
        <!-- These empty option boxes are to set a fixed left alignment on the bottom row -->
      </div>
      <div v-if="question.directiveMapping.alternateOptionText" class="text-center">
        <a href="javascript:void(0)" @keydown.space="noneApply(options, $event)" v-on:click="noneApply(options)">{{ question.directiveMapping.alternateOptionText }}</a>
      </div>
      <div v-if="question.directiveMapping.alternateOptionText" class="mb-2 invalid-feedback" :class="{'d-block': v$.$error}">
        Please select an option
      </div>
      <div v-else class="mb-2 invalid-feedback" :class="{'d-block': v$.$error}">
        Please select at least one option
      </div>
    </div>
    <div v-else id="basicInfoQuestionMultiSelect">
      <p class="mb-4">What purpose would your loan serve? Select all that apply</p>
      <div class="row row-cols-3 g-0 gap-2" :dreams-id="question.attributes[0].alias">
        <label
          class="selection-pill py-0 px-2 p-sm rounded text-center position-relative col vertical-align"
          v-bind:class="{
            'selection-pill--selected': option.boolValue,
            'selection-pill--focused': option.focused,
            'selection-pill--invalid': v$.valueArray && v$.valueArray.$error,
          }"
          v-for="(option, index) in options"
          :key="index"
          :for="'biq-' + question.id + '-' + index"
          :tabindex="index + 1"
          @keydown.enter="onEnter(options)"
          @keydown.space="toggleValue(option, options, $event)">
          <div class="option-box text-center d-table w-100">
            <input type="checkbox"
                   class="selection-pill__check position-absolute top-0 start-0 bottom-0 end-0"
                   :id="'biq-' + question.id + '-' + index"
                   :name="'biq-' + question.id + '-' + index"
                   @focus="onFocus(option)"
                   @blur="onBlur(v$, option)"
                   @change="saveValue(options)"
                   v-model="option.boolValue">

            <div class="option-box__label d-table-cell align-middle p-xs">
              {{ option.label }}
            </div>
          </div>
        </label>
        <!-- These empty option boxes are to set a fixed left alignment on the bottom row -->
        <span v-if="options.length > 4" class="flex-spacer "></span>
        <span v-if="options.length > 4" class="flex-spacer "></span>
        <span v-if="options.length > 4" class="flex-spacer "></span>
        <!-- These empty option boxes are to set a fixed left alignment on the bottom row -->
      </div>
      <p class="text-danger" v-if="v$.valueArray && v$.valueArray.$error">Select an answer</p>
      <div v-if="question.directiveMapping.alternateOptionText" class="text-center">
        <a href="javascript:void(0)" @keydown.space="noneApply(options, $event)" :tabindex="options.length" v-on:click="noneApply(options)">{{ question.directiveMapping.alternateOptionText }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'
import includes from 'lodash/includes'
import cloneDeep from 'lodash/cloneDeep'
import { mapState } from 'pinia'
import { useQuestionsStore } from '~/store/questions'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  emits: ['invalidity', 'answer'],
  setup: () => ({ v$: useVuelidate() }),
  data () {
    return {
      options: this.formatToBooleans(),
      valueArray: []
    }
  },
  created: function() {
    this.$watch('v$.$invalid', (invalid) => {
      this.$emit('invalidity', invalid)
    }, {immediate: true})
  },
  computed: {
    ...mapState(useQuestionsStore, {
      singleForm: store => get(store, 'singleForm'),
    }),
    noneFocused() {
      return this.options.filter( o => o.focused === true ).length === 0
    },
  },
  validations() {
    return {
      valueArray: {
        required
      },
    }
  },
  methods: {
    noneApply (options, event) {
      if (event) {
        event.preventDefault()
      }

      options = (options).map((option) => {
        option.boolValue = false
        return option
      })

      const submitImmediately = true
      this.saveValue(options, submitImmediately)
    },
    onEnter (options) {
      const anyTrue = !!options.filter((opt) => {
        return opt.boolValue
      }).length
      // Prevent people from pressing enter accidentally and submitting 'none apply'
      if (anyTrue) {
        this.saveValue(options, true)
      }
    },
    onFocus (option) {
      option['focused'] = true
    },
    onBlur (v$, option) {
      option['focused'] = false
      setTimeout(() => {
        if (this.noneFocused) {
          v$.$touch()
        }
      }, 0)
    },
    formatToBooleans () {
      let string = get(this.question, 'attributes[0].value')
      let values = []

      if (string) {
        values = string.split(',')
      }

      let _question = cloneDeep(this.question)

      if (!_question.directiveMapping.options && _question.attributes[0].options) {
        _question.directiveMapping.options = _question.attributes[0].options
      }

      const options = _question.directiveMapping.options.map((option) => {
        if (includes(values, option.value)) {
          option.boolValue = true
        } else {
          option.boolValue = false
        }
        return option
      })

      this.valueArray = options
        .filter(opt => opt.boolValue)
        .map(opt => opt.value)

      return options
    },
    toggleValue (option, options, event) {
      event.preventDefault()
      option.boolValue = !option.boolValue
      this.saveValue(options, this.singleForm)
      return option
    },
    saveValue (options, submitImmediately = false) {
      this.v$.$touch()

      this.valueArray = options
        .filter(opt => opt.boolValue)
        .map(opt => opt.value)

      this.v$.valueArray.$validate()

      let vals = this.valueArray.length > 0 ? this.valueArray.join(',') : null

      // Quick patch fix, if alternate option text exists, then allow none as an option
      if (this.question.directiveMapping.alternateOptionText && this.valueArray.length === 0) {
        vals = 'none'
      }

      let returnAttr = {
        alias: this.question.attributes[0].alias,
        value: vals
      }

      const isInvalid = this.v$.valueArray.$invalid

      if (this.singleForm && returnAttr.value === null) {
        this.$emit('answer', { attr: [returnAttr], submitImmediately, isInvalid: false})
      } else {
        this.$emit('answer', { attr: [returnAttr], submitImmediately, isInvalid })
      }
    }
  },
  props: {
    question: Object,
    invalidity: Object,
  },
  watch: {
    question: {
      // This cannot be an arrow function or it won't have reference to methods
      handler: function (newVal, oldVal) {
        this.options = this.formatToBooleans()
      }
    }
  }
}
</script>

<style scoped lang="scss">

.selection-pill {
  width: 31%;
  @include media-breakpoint-up(lg) {
    width: 112px;
  }
  max-width: 112px;
  height: 48px;
  border: 1px solid $border-100;

  cursor: pointer;
}

.single-form-selection-pill {
  width: 150px;
  @include media-breakpoint-down(sm) {
    width: 47%
  }
  border: 1px solid $neutral-300;
  cursor: pointer;
}

.selection-pill--focused {
  box-shadow: 0 0 0 0.25rem rgb(5 194 240 / 25%);
}
.selection-pill--selected {
  border: 2px solid $blue-300;
}
.selection-pill--invalid {
  border-color: $red;
}
.option-box__label {
  height: 46px;
}

.single-form-option-box__label {
  height: 50px;
}

.selection-pill__check {
  opacity: 0;
  cursor: pointer;
}

.single-form-flex-spacer {
  flex-basis: 150px;
  height: 0;
  margin: 0;
}

.flex-spacer {
  //flex-basis: 130px;
  height: 0;
  margin: 0;
}
</style>
